import { render, staticRenderFns } from "./editNotice.vue?vue&type=template&id=7c8e2ebf&scoped=true&"
import script from "./editNotice.vue?vue&type=script&lang=js&"
export * from "./editNotice.vue?vue&type=script&lang=js&"
import style0 from "./editNotice.vue?vue&type=style&index=0&id=7c8e2ebf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8e2ebf",
  null
  
)

export default component.exports